export default __webpack_public_path__ + "images/7351d20d15314d5667d243e5eb68f10a-truemed-icon.svg";